/**
 * Linhas da exportacao de Respostas (FORM-26) — puro, sem React.
 *
 * Uma coluna por rotulo de campo (atuais e removidos, FORM-17), origem com
 * rotulo, situacao no CRM, numero do lead, UTMs e data/hora local. Celula
 * que comeca com = + - @ ganha apostrofo: sem isso, "=HYPERLINK(...)" digitado
 * num campo de texto vira formula viva quando o gestor abre o Excel.
 */
import { formatarRecebidaEm, formatarValorResposta, rotuloEfeitoLead, rotuloOrigem, rotuloStatusIntegracao } from "./respostasFormat";

export const PAINEL_EXPORTACAO_RESPOSTAS = "formulario-respostas";

const INICIO_DE_FORMULA = /^[=+\-@]/;

/** Texto seguro para planilha: prefixo ' quando o Excel leria como formula. */
export function neutralizarFormula(texto) {
  if (texto === null || texto === undefined) return "";
  const valor = String(texto);
  return INICIO_DE_FORMULA.test(valor) ? `'${valor}` : valor;
}

/** Chaves de UTM presentes em alguma resposta, na ordem em que aparecem. */
export function chavesDeUtm(respostas) {
  const chaves = [];
  respostas.forEach((r) => {
    const utm = r?.utm && typeof r.utm === "object" ? r.utm : {};
    Object.keys(utm).forEach((k) => {
      if (!chaves.includes(k)) chaves.push(k);
    });
  });
  return chaves;
}

/**
 * Monta {titulo, secoes:[{id, label, columns, rows}]} para salvarPDF /
 * salvarExcel / salvarCSV. `colunas` vem de `colunasDeCampos`.
 */
export function montarExportacaoRespostas({ formulario, respostas = [], colunas = [], filtros = [] }) {
  const utms = chavesDeUtm(respostas);
  const columns = [
    { key: "recebida_em", label: "Recebida em", type: "text" },
    { key: "origem", label: "Origem", type: "text" },
    { key: "lead", label: "Lead", type: "text" },
    { key: "integracao", label: "Integração", type: "text" },
    { key: "efeito", label: "Efeito no CRM", type: "text" },
    ...colunas.map((c) => ({
      key: `campo_${c.id}`,
      label: c.removido ? `${c.label} (removido)` : c.label,
      type: "text",
    })),
    ...utms.map((k) => ({ key: `utm_${k}`, label: k, type: "text" })),
  ];
  const rows = respostas.map((r) => {
    const linha = {
      recebida_em: formatarRecebidaEm(r.created_at),
      origem: rotuloOrigem(r.origem_submissao),
      lead: neutralizarFormula(r.lead_numero || ""),
      integracao: rotuloStatusIntegracao(r.status_integracao),
      efeito: rotuloEfeitoLead(r.efeito_lead),
    };
    colunas.forEach((c) => {
      const valor = formatarValorResposta(c.campo, r.dados?.[c.id]);
      linha[`campo_${c.id}`] = valor === "—" ? "" : neutralizarFormula(valor);
    });
    const utm = r?.utm && typeof r.utm === "object" ? r.utm : {};
    utms.forEach((k) => {
      linha[`utm_${k}`] = neutralizarFormula(utm[k] ?? "");
    });
    return linha;
  });
  const nome = formulario?.nome || "Formulário";
  return {
    titulo: `Respostas — ${nome}`,
    filtros,
    resumo: [{ label: "Respostas", value: respostas.length, type: "number" }],
    secoes: [{ id: "respostas", label: "Respostas", columns, rows }],
  };
}
